import { observable, action } from 'mobx';
import _ from "lodash";
import {ajax, Loadable, Validator as V } from 'hrone-react';
import utils from '../../../assets/utils';

class LoginStore extends V.BaseStore {
    @observable
    loginForm = {
        areaCode: '',
        loginName: '',
        password: '',
    };
    @observable isForeignPhone = false;

    areaCodeOptions = [
        {
            value: '+86',
            label: '+86',
        },
        {
            value: '+12',
            label: '+12',
        },
        {
            value: '+44',
            label: '+44',
        },
        {
            value: '+001',
            label: '+001',
        },
    ];

    @action
    clearStore = () => {
        this.loginForm = {
            areaCode: '',
            loginName: '',
            password: '',
        };
    };

    @action
    toLoginWithForeignCell = () => {
        this.isForeignPhone = !this.isForeignPhone;
        this.clearStore();
        this.clearValidationResult();
    };

   @observable loadingCom = undefined as Loadable;

    @action
    submit = () => {
        if (!this.validate()) return;
        this.loadingCom &&  this.loadingCom.start();
        ajax.post('/v1/kiosk-web/login/login', {
                areaCode: _.trim(this.loginForm.areaCode),
                loginName: _.trim(this.loginForm.loginName),
                password: utils.encryptByDESModeEBC(_.trim(this.loginForm.password)),
            }).then(data => {
                sessionStorage.setItem('sessionId', data.webSession);
                utils.ToAppPage();
            }, ()=>{this.loadingCom && this.loadingCom.finish();});
    };

    @action
    clearValidation = () => {
        this.clearValidationResult();
    };

    getValidationConfig() {
        return {
            'loginForm.loginName': {
                required: true,
            },
            'loginForm.password': {
                required: true,
            },
        };
    }
}

export default new LoginStore();
